import { PlusCircle } from "@/styles/icons";
import { useState } from "react";
import {
    Button,
    Modal,
    ModalProps,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Flex,
    Progress,
    Box,
    Text,
  } from "@chakra-ui/react";
  
  interface Step {
    title: string;
    content: React.ReactNode;
    onNext?: () => void;
    onBack?: () => void;
  }

  interface FormModalProps {
    isOpen: boolean;
    isSubmitting: boolean;
    onClose: () => void;
    handleConfirmModal: () => void;
    title: string;
    confirmationButtonText?: string;
    disableWhenIsFormEmpty?: boolean;
    type?: "ADD" | "EDIT" | "DELETE";
    steps?: Step[];
    isCentered?: boolean;
  }
  
  const FormModal2: React.FC<FormModalProps> = ({
    isOpen,
    isSubmitting,
    onClose,
    handleConfirmModal,
    title,
    confirmationButtonText = "Adicionar",
    disableWhenIsFormEmpty = false,
    type,
    steps,
    isCentered = true,
  }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const totalSteps = steps?.length || 0;

    function formatIconType(type) {
      const iconTypes = {
        ADD: <PlusCircle />,
        EDIT: <></>,
        DELETE: <></>,
      }
      return iconTypes[type] || <></>;
    }

    const handleNext = () => {
      if (currentStep < totalSteps - 1) {
        steps?.[currentStep]?.onNext?.();
        setCurrentStep(currentStep + 1);
      } else {
        handleConfirmModal();
      }
    };

    const handleBack = () => {
      if (currentStep > 0) {
        steps?.[currentStep]?.onBack?.();
        setCurrentStep(currentStep - 1);
      }
    };

    const renderProgressBar = () => {
      if (!steps || steps.length <= 1) return null;
      
      return (
        <Box>
          <Flex justify="space-between" mb={2}>
            <Text fontSize="sm" color="gray.600">
              Passo {currentStep + 1} de {totalSteps}
            </Text>
            <Text fontSize="sm" color="gray.600">
              {steps[currentStep]?.title}
            </Text>
          </Flex>
          <Progress 
            value={((currentStep + 1) / totalSteps) * 100} 
            size="sm" 
            colorScheme="pink"
          />
        </Box>
      );
    };

    return (
      <Modal isOpen={isOpen} onClose={onClose} isCentered={isCentered}>
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleConfirmModal}>
          <ModalHeader
            display="flex"
            alignItems="center"
            gap="1rem"
          >
            {formatIconType(type)} {title}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody 
            p="24px" 
            borderTop="1px solid" 
            borderBottom="1px solid" 
            borderColor="gray.50"
            display="flex"
            flexDir="column"
            gap="1rem"
          >
            {renderProgressBar()}
            {steps[currentStep]?.content}
          </ModalBody>
          <ModalFooter>
            <Flex 
              w="100%"
              justifyContent="right"
              gap={4}
            >
              {currentStep > 0 && (
                <Button 
                  variant="cancel2"
                  onClick={handleBack}
                >
                  Voltar
                </Button>
              )}
              <Button 
                id={confirmationButtonText === "Adicionar" ? "recebimento_manual" : ""}
                variant="primary2"
                type="submit" 
                isDisabled={isSubmitting || disableWhenIsFormEmpty}
                isLoading={isSubmitting}
                _disabled={{
                  bgColor: "neutral.3",
                  border: "1px solid",
                  borderColor: "neutral.200",
                  cursor: "not-allowed",
                  color: "rgba(0, 0, 0, 0.25)",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  handleNext();
                }}
              >
                {currentStep === totalSteps - 1 ? confirmationButtonText : "Próximo"}
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };

  export { FormModal2 }